module.exports = __webpack_public_path__ + "static/logo-152b3c033c4bc6319b7f6c1825ccf2f1.png";